import script from "./IamUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./IamUsers.vue?vue&type=script&setup=true&lang=js"

import "./IamUsers.vue?vue&type=style&index=0&id=488ad58e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-488ad58e"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSpace,QSelect,QInput,QBtn,QTable,QTd,QChip,QDialog,QCard,QCardSection,QSeparator,QForm,QToggle,QCardActions,QField});qInstall(script, 'directives', {ClosePopup});
